import React from "react"
import MindFullnessImg from "../../images/mind-fullness.svg"
import FunctionalTrainingImg from "../../images/functional-training.svg"
import StrechingImg from "../../images/streching.svg"
import BodycareYogaImg from "../../images/bodycare-yoga.svg"

const HealthWellness = () => {
  return (
    <section className="container mx-auto px-6 py-12">
      <h3 className="text-6xl pb-20 font-normal leading-tight text-center">
        <span className="text-secondary block font-bold">Health &</span>{" "}
        Wellness
      </h3>
      <div className="flex flex-col md:flex-row-reverse items-center pb-12">
        <div className="w-full md:w-1/2 pb-8">
          <img src={MindFullnessImg} alt="MindFullness" className="mx-auto" />
        </div>
        <div className="w-full md:w-1/2">
          <h4 className="text-4xl font-bold pb-4">MindFullness</h4>
          <p className="pb-4">
            Mindfulness helps us to regain our internal balance, considering the
            individual as an integral whole, which includes: body, mind and
            spirit.
          </p>
          <p className="pb-8">
            By practicing mindfulness, we develop a greater capacity for
            discernment and compassion.
          </p>
          <p className="italic font-medium">#AvalithMeditation</p>
        </div>
      </div>

      <div className="flex flex-col md:flex-row items-center pb-12">
        <div className="w-full md:w-1/2 pb-8">
          <img
            src={FunctionalTrainingImg}
            alt="Functional Training"
            className="mx-auto"
          />
        </div>
        <div className="w-full md:w-1/2">
          <h4 className="text-4xl font-bold pb-4">Functional Training</h4>
          <p className="pb-8">
            In surfing we find joy, fun, freedom, off-the-grid time, contact
            with nature, among many other positive feelings. However, in order
            to enjoy all these, we have to take care of our physical health.
            That's why Avalith offers the opportunity to train our aerobic and
            anaerobic energy systems.
          </p>
          <p className="italic font-medium">#AvalithSurf #TrainingActivity</p>
        </div>
      </div>

      <div className="flex flex-col md:flex-row-reverse items-center pb-12">
        <div className="w-full md:w-1/2 pb-8">
          <img src={StrechingImg} alt="Streching" className="mx-auto" />
        </div>
        <div className="w-full md:w-1/2">
          <h4 className="text-4xl font-bold pb-4">Streching</h4>
          <p className="pb-8">
            Stretching seeks relaxation and strengthening of muscles through
            gentle and conscious exercises that can be practiced by anyone,
            regardless of age or physical condition.
          </p>
          <p className="italic font-medium">#Stretching</p>
        </div>
      </div>

      <div className="flex flex-col md:flex-row items-center pb-12">
        <div className="w-full md:w-1/2 pb-8">
          <img src={BodycareYogaImg} alt="BodyCare, Yoga" className="mx-auto" />
        </div>
        <div className="w-full md:w-1/2">
          <h4 className="text-4xl font-bold pb-4">Yoga</h4>
          <p className="pb-4">
            Yoga teaches you how to cultivate your body and mind.
          </p>
          <p className="pb-8">
            You can do five-minute classes (Active Pauses), or full sessions
            (classes) to recharge your energy every time you need it.
          </p>
          <p className="italic font-medium">
            #Yogui #AvalithYogui #HomeYoga
          </p>
        </div>
      </div>
    </section>
  )
}

export default HealthWellness
